import type { ReactNode } from "react";

/** Shared grid-backed icon frame for criteria evaluation progress states. */
export function CriteriaEvaluationStateGraphic({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className="mb-8 flex h-64 w-72 items-center justify-center"
      aria-hidden="true"
      style={{
        backgroundImage:
          "linear-gradient(to right, #E6E6E6 1px, transparent 1px), linear-gradient(to bottom, #E6E6E6 1px, transparent 1px)",
        backgroundSize: "2.5rem 2.5rem",
        maskImage:
          "radial-gradient(circle at center, black 20%, transparent 72%)",
        WebkitMaskImage:
          "radial-gradient(circle at center, black 20%, transparent 72%)",
      }}
    >
      <div
        className={`${className} flex h-16 w-16 items-center justify-center border border-primaryGray-6 bg-white shadow-[0.5rem_0.5rem_0_#2E2E2E]`}
      >
        {children}
      </div>
    </div>
  );
}

export default CriteriaEvaluationStateGraphic;
